import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import { useIntl, Link } from "gatsby-plugin-intl"

import { navigate } from "gatsby"

import formattingJson from "../scripts/formattingJson"
import HTMLEntities from "../scripts/HTMLEntities"

export default function GoodPracticesTemplate({ data }) {
  const content = data.goodPracticesJson
  const intl = useIntl()

  // Redirect to list of good practices if name of the good practice is empty
  const isBrowser = typeof window !== "undefined"
  if (isBrowser) {
    if (content.name[intl.locale] === "") {
      navigate("/good-practices/")
      return null
    }
  }

  return (
    <Layout>
      <Seo title={content.name[intl.locale]} lang={intl.locale} />
      <section className="goodpractices__banner">
        <div className="bannerGradient">
          <div className="bannerGradient--container">
            <div className="bannerGradient--inner">
              <p className="bannerGradient--smallText">
                <Link to="/">The Good Manager</Link>
                &nbsp; {">"} &nbsp;
                {/* <Link to="/good-practices" className="bannerGradient--framed">{intl.formatMessage({ id: "menu8" })}</Link>
          &nbsp; > &nbsp; */}
                <Link to="/good-practices">
                  {intl.formatMessage({ id: "menu8" })}
                </Link>
                &nbsp; {">"} &nbsp;
                {content.name[intl.locale]}
              </p>
              <h1>{content.name[intl.locale]}</h1>
              <p className="goodpractices__banner--cat">
                {content.gptarget[intl.locale].slice(4)} - {content.country[intl.locale]}
              </p>
              <p className="goodpractices__banner--lemniscate">∞</p>
              <p className="goodpractices__banner--company">
                {content.type[intl.locale]}, {content.size[intl.locale]}
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="content--fullwidth">
        <div id="goodpractices__content" className="content--main">
          <section className="goodpractices__presentation--before">
            <h2>{intl.formatMessage({ id: "goodpractices19" })}</h2>
          </section>
          <section className="content--main--framed whiteBackground goodpractices__presentation--content">
            <div>
              {content.description[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices20" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.description[intl.locale])) }}></div>
                </>
              )}

              {content.digital[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices21" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.digital[intl.locale])) }}></div>
                </>
              )}

              {content.gptarget[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices12" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.gptarget[intl.locale].slice(4))) }}></div>
                </>
              )}

              {content.url[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices34" })}</h2>
                  <p>
                    <a href={content.url[intl.locale]}>{content.url[intl.locale]}</a>
                  </p>
                </>
              )}
            </div>

            <div>
              {content.gp[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices22" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.gp[intl.locale])) }}></div>
                </>
              )}

              {content.cost[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices23" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.cost[intl.locale])) }}></div>
                </>
              )}

              {content.starting[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices24" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.starting[intl.locale])) }}></div>
                </>
              )}

              {content.time[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices25" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.time[intl.locale])) }}></div>
                </>
              )}

              {content.tools[intl.locale] && (
                <>
                  <h2>{intl.formatMessage({ id: "goodpractices26" })}</h2>
                  <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.tools[intl.locale])) }}></div>
                </>
              )}
            </div>
          </section>

          {content.interview[intl.locale] && (
            <section className="goodpractices__interview--before">
              <h2>{content.interview[intl.locale]}</h2>
              {/* <h2>{intl.formatMessage({ id: "goodpractices27" })}</h2> */}
            </section>
          )}
        </div>
      </div>

      {content.benefits[intl.locale] && (
        <section>
          <div className="spacingBlock--resetMargin lightBlueBackground"></div>

          <div className="content--fullwidth">
            <div className="content--main goodpractices__interview--content">
              <div>
                <h2>{intl.formatMessage({ id: "goodpractices28" })}</h2>
              </div>
              <div className="content--main--framed whiteBackground">
                <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.benefits[intl.locale])) }}></div>
              </div>
            </div>
          </div>
        </section>
      )}

      {content.constraints[intl.locale] && (
        <section>
          <div className="spacingBlock--resetMargin lightBlueBackground"></div>
          <div className="content--fullwidth">
            <div className="content--main goodpractices__interview--content">
              <div>
                <h2>{intl.formatMessage({ id: "goodpractices29" })}</h2>
              </div>
              <div className="content--main--framed whiteBackground">
                <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.constraints[intl.locale])) }}></div>
              </div>
            </div>
          </div>
        </section>
      )}

      {content.advice[intl.locale] && (
        <section>
          <div className="spacingBlock--resetMargin lightBlueBackground"></div>
          <div className="content--fullwidth">
            <div className="content--main goodpractices__interview--content">
              <div>
                <h2>{intl.formatMessage({ id: "goodpractices30" })}</h2>
              </div>
              <div className="content--main--framed whiteBackground">
                <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.advice[intl.locale])) }}></div>
              </div>
            </div>
          </div>
        </section>
      )}

      {content.nextsteps[intl.locale] && (
        <section>
          <div className="spacingBlock--resetMargin lightBlueBackground"></div>
          <div className="content--fullwidth">
            <div className="content--main goodpractices__interview--content">
              <div>
                <h2>{intl.formatMessage({ id: "goodpractices31" })}</h2>
              </div>
              <div className="content--main--framed whiteBackground">
                <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.nextsteps[intl.locale])) }}></div>
              </div>
            </div>
          </div>
        </section>
      )}

      {content.other[intl.locale] && (
        <section>
          <div className="spacingBlock--resetMargin lightBlueBackground"></div>
          <div className="content--fullwidth">
            <div className="content--main goodpractices__interview--content">
              <div>
                <h2>{intl.formatMessage({ id: "goodpractices32" })}</h2>
              </div>
              <div className="content--main--framed whiteBackground">
                <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.other[intl.locale])) }}></div>
              </div>
            </div>
          </div>
        </section>
      )}
    </Layout>
  )
}

export const wikiElement = graphql`
  query($slug: String!) {
    goodPracticesJson(fields: { slug: { eq: $slug } }) {
      advice { en,fr,it,es,bg }
      benefits { en,fr,it,es,bg }
      constraints { en,fr,it,es,bg }
      cost { en,fr,it,es,bg }
      country { en,fr,it,es,bg }
      description { en,fr,it,es,bg }
      digital { en,fr,it,es,bg }
      fields {
        slug
      }
      gp { en,fr,it,es,bg }
      gptarget { en,fr,it,es,bg }
      interview { en,fr,it,es,bg }
      name { en,fr,it,es,bg }
      nextsteps { en,fr,it,es,bg }
      other { en,fr,it,es,bg }
      sector { en,fr,it,es,bg }
      size { en,fr,it,es,bg }
      starting { en,fr,it,es,bg }
      time { en,fr,it,es,bg }
      tools { en,fr,it,es,bg }
      type { en,fr,it,es,bg }
      url { en,fr,it,es,bg }
    }
  }
`
